module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapter 1—Theo")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("ENJOYING THE")]), _vm._v(" weightlessness as the plane lifted into the air, I studied my boyfriend"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("as he excitedly watched the world shrink below us. His enthusiasm for everything sent sympathetic thrills through me, and I was soon grinning.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It had been an unexpectedly blissful couple of months with only one small hiccup. A week after Robbie moved in, for some strange reason I felt the need to define the parameters of our relationship. It was a first for both of us. Many firsts. I was his "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("first ")]), _vm._v("everything; he was my first boyfriend. I can’t remember how the conversation started, but vaguely recall me saying that I’d like to get some clarification.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We haven’t really talked about us.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What do you mean?”"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("he had asked, his lips naturally curved curiously. One of the things I learned was that Robbie is never plagued with the same doubts about relationships that it seems like the rest of us have. Or at least that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I ")]), _vm._v("have"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("had my entire life. He’s "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("wholesome")]), _vm._v(", and I know how that sounds, but it’s true. His very nature is one of trust and acceptance.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had never experienced any doubt until I stupidly said, “Well, exclusivity, monogamy, I"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("don’t know. Just curious what you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t understand. You’re my boyfriend….”"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("Though his curiosity had turned to confusion, I pressed on.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, but that’s for now. I just don’t want you to feel held back. You know, if you want to bang someone and—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head, his confusion intensifying and darkening into something else. “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Why are you saying this")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I just don’t want to break up over—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Break up? Why… why would we ever break up?”"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("His emerald eyes shone with tears that had made my heart immediately ache. I had done that to him. If I live to be a thousand years old, that look will always haunt me. That with a simple and quite stupid misspoken phrase I could hurt him so much.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why are you frowning?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I turned to find him gazing at me intently. Robbie took my hand, shaking his head with concern.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I chuckled. “Ah, sugar… just about how foolish I was.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’re gonna have to be more specific,” he said with the sweetest smile that had me falling back laughing. My boyfriend had quickly caught on to sarcasm and the importance of a good burn.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I shook my head at myself. “You remember that conversation we had when you first moved in? The one about monogamy?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, when you pointed out that I’m only eighteen and had only… how did you put it? ‘Boned one guy’? That you thought you were holding me back?” he asked, relaxing as he settled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. That’s it. And you turned it around and asked if you were holding me back.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And you said no, because you’re a slut who was settling down.” Robbie was on a roll.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I laughed again. “Not… quite. Anyway, I was just remembering that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I thought your talk with Kat had fixed all that?” he asked curiously.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I sat up so quickly I almost gave myself whiplash. Robbie just smiled knowingly. “Oh yeah, I heard the whole thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I guess Kat had seen that I was mopey after I left Robbie. I had brought my laptop to the comfortable bucket chair of the custom outdoor patio and plopped down. And I had had no clue Robbie was around.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kat just settled into the adjacent bucket, tucked her legs up under her, and gave me one of those serene “I’m here to listen” expressions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Look,”"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("I finally grunted out. “I broached the subject with Robbie that he would probably be moving on from here, from me, someday and wanted to let him know I was fine. Had just… I don’t know, fuck, wanted him to know I’d rather have him bang someone else and not break up.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her look had mirrored Robbie’s to an extent. Confusion. Sadness. But also compassion and understanding. “You’re afraid of losing him.”"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("It was clearly stated and absolute truth that had cut to the bone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She told you to get your head out of your ass,” he reminded me of the exact words she went on to say, and I realized he was still holding my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I chuckled and tilted my head to him. “Indeed she did. She said a lot of things….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Like how your first boyfriend broke your heart?” he said so softly I barely heard it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We were kids. I thought it was more than it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She pointed out that you were scared of me leaving too,” Robbie said, swallowing hard. A shadow crossed over his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah,” I admitted lamely. Kat and I had talked about how amazing Robbie was, and she had made me come to terms with the fact that I was a big scared baby. Hell, he had heard all that?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Theo, I know that I’m not worthy of being with you, but I’m glad we’re together,” Robbie said earnestly, causing my heart to drop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Not worthy—what are you talking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You and Kat. You talked about how amazing you thought I was, but I’m not. It doesn’t feel like that at all. You’re the amazing one.” Robbie’s eyes lit up, and he gave me that radiant smile he saves just for me. A smile that would often disappear into something more reserved if someone else was around.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Patting his hand, I said, “Guess we can both think the other is perfect, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He nodded eagerly, joy returning to his eyes when he leaned over and gave me a small kiss on the cheek. I turned my attention to the window, tilting my chin to it, silently acknowledging he should continue his enjoyment of the world outside so I could continue my internal mental review of the last couple of months.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 69
// module chunks = 0